var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormUploadPoster.jinja');
require('./SubmissionFormUploadPoster.less');

var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'change .SubmissionFormUploadPoster-input': 'changePoster',
        'click .SubmissionFormUploadPoster-delete': 'deletePoster'
    },

    tempFilesApi: function () {
        return (UrlsFront['front:api:files:temp-file-upload']());
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this,  'tempFilesApi');

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        this.resetPosterLoading();

        return SubmissionFormBlock.prototype.deactivate.call(this, params);
    },


    changePoster: function (e) {
        if (!e.target.files || !e.target.files.length) return;

        this.resetPosterLoading();

        var $input = $(e.currentTarget);
        var $wrapper = this.$('.SubmissionFormUploadPoster-cover');
        var $img = $wrapper.find('.SubmissionFormUploadPoster-image');
        var fil = e.target.files[0];
        var self = this;

        $wrapper.attr('data-state', 'loading');
        $input.attr('data-file', '');

        this.posterLoadXhr = new XMLHttpRequest();
        this.posterLoadXhr.open('POST', this.tempFilesApi());

        this.posterLoadXhr.onload = function (res, data) {
            var responseObject = app.AdoptTempFileObject(this.responseText, 'image');

            $input.attr('data-file', JSON.stringify(responseObject));
            $input.attr('data-new', '1');
            $wrapper.attr('data-state', 'loaded');

            $img.attr('src', responseObject.tempImg);
        };

        this.posterLoadXhr.onerror = function () {
            $wrapper.attr('data-state', 'error');
        };

        var formData = new FormData();
        formData.append('file', fil);
        this.posterLoadXhr.send(formData);

        $input.val('');
    },


    deletePoster: function (e) {
        var $wrapper = this.$('.SubmissionFormUploadPoster-cover');
        var $input = $wrapper.find('input[type="file"]');
        var $img = $wrapper.find('.SubmissionFormUploadPoster-image');

        $wrapper.attr('data-state', 'empty');
        $input.attr('data-file', '');
        $img.removeAttr('src');

        this.resetPosterLoading();
    },


    resetPosterLoading: function () {
        this.posterLoadXhr && this.posterLoadXhr.abort();
    },


    checkRequired: function () {
        return true;
    },


    getFormData: function () {
        var $input = this.$('.SubmissionFormUploadPoster-input');
        var fileData = $input.attr('data-file');
        fileData = fileData ? JSON.parse(fileData) : null;

        return {
            'assetsCover': fileData
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormUploadPoster.js
// module id = 126
// module chunks = 0